import {
  collection,
  DocumentData,
  query,
  QueryDocumentSnapshot,
} from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { getDate } from "@poseidon/firebase/timestamp";

export const useAgreements = () => {
  const [agreements, setAgreements] = useState<DocumentData[]>([]);
  const [value, loading, error] = useCollection(
    query(collection(db, "agreements"))
  );
  useEffect(() => {
    const docs = value ? value.docs.map(mapAgreement) : [];
    setAgreements(docs);
  }, [value]);

  return { agreements, loading, error };
};

const mapAgreement = (snapshot: QueryDocumentSnapshot) => {
  if (!snapshot.exists()) {
    return {};
  }

  const documentData = snapshot.data();
  return {
    id: snapshot.id,
    documentReference: snapshot.ref,
    ...documentData,
    agreementCreation: getDate(documentData["agreementCreation"]),
  };
};
